/**
 * @author (original) alteredq / http://alteredqualia.com/
 * @author (ES version) teel
 */
import Pass from 'demo/postprocessing/Pass';

export default class ClearMaskPass extends Pass {
  constructor() {
    super();
    this.needsSwap = false;
  }

  render(renderer, writeBuffer, readBuffer, delta, maskActive) {
    renderer.state.buffers.stencil.setTest(false);
  }
}
